module.exports = __webpack_public_path__ + "img/1504942037.9191714c.jpg";